/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

import queryString from "query-string"
import { useEffect, useState } from "react"
import dayjs from "dayjs"
import { 区分分類コード } from "../../../constant/enum/codes"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { showInfoToast } from "../../../components/CustomToast"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { e締め確定区分 } from "../../../constant/enum/master"
import { RootState } from "../../../globalStore/rootreducer"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import KubunService from "../../../service/master/kubun/kubunService"
import {
  TGetuziSimesyoriListGetReq,
  TGetuziSimesyoriPutReq,
  T月次締処理,
} from "../../../service/master/getuziSimesyori/TGetuziSimesyori"
import {
  T年ComboBoxItem,
  YearComboBox,
} from "../../../components/ComboBox/YearComboBox"
import ComboBox from "../../../components/ComboBox"
import GetuziSimesyoriService from "../../../service/master/getuziSimesyori/getuziSimesyoriService"

//#region [type]
type T締め年月入力Item = {
  月: number
  締め状態: number
}

const e締め状態 = {
  未確定: 0,
  確定: 1,
}
//#endregion

/**
 * 月次締め処理管理マスタ
 * @returns
 */
const GetuziSimesyoriRegister = () => {
  const history = useHistory()
  const location = useLocation()

  // ref
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "GetuziSimesyoriRegister_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<T月次締処理>,
    isEmptyCollection?: boolean
  ) => {
    // 初期状態用
    if (isEmptyCollection)
      return new wjCore.CollectionView<T締め年月入力Item>([])

    const newList: T締め年月入力Item[] = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,
    ].map((m) => {
      return {
        月: m,
        締め状態: e締め状態.未確定,
      }
    })
    // 既存データの適用
    data.forEach((d) => {
      const monthItem = newList.find(
        (item) => item.月 === dayjs(d.年月).month() + 1
      )
      if (monthItem) monthItem.締め状態 = e締め状態.確定
    })
    return new wjCore.CollectionView<T締め年月入力Item>(newList)
  }

  const beforeSearch = () => {
    // TODO:バリデーションチェック
    if (!isValidationCheckBeforeSearch()) return
    search()
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TGetuziSimesyoriListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    disPatch(clearAlert()) // アラートを非表示に
    setIsSubmitButton(false)

    let currentSearchCondition: TGetuziSimesyoriListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      setPrevSearchCondition(currentSearchCondition)
      const res = await new GetuziSimesyoriService().getList(
        currentSearchCondition
      )

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data) })
      setAccordionController(false)
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
      setIsSubmitButton(true)
      flexGrid?.refresh()
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query = queryString.parse(location.search)
    const query年 = query["年"]?.toString()
    const query締め確定区分コード = query["締め確定区分コード"]?.toString()
    let casted年 = parseInt(dayjs(eigyobi).format("YYYY"))
    try {
      if (query年) casted年 = parseInt(query年)
    } catch (err) {}
    const casted: TGetuziSimesyoriListGetReq = {
      年: casted年,
      締め確定区分コード: query締め確定区分コード ?? "",
    }
    set年(casted.年)
    set締め確定区分コード(casted.締め確定区分コード)
    return casted
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TGetuziSimesyoriListGetReq => {
    return {
      年,
      締め確定区分コード: 締め確定区分コード ?? "",
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TGetuziSimesyoriListGetReq
  ) => {
    return {
      年: searchCondition.年,
      締め確定区分: 締め確定区分ItemsSource?.find(
        (i) =>
          i.区分コード === searchCondition.締め確定区分コード &&
          i.分類コード === 区分分類コード.マスタ.締め確定区分
      )?.名称1,
    }
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    // ヘッダのみAlignを調整する
    grid.itemFormatter = (panel, r, c, cell) => {
      if (panel.cellType === wjcGrid.CellType.ColumnHeader) {
        cell.style.textAlign = "center"
      }
    }

    grid.refresh()
  }

  /**
   * グリッドのフォーマット 祝日
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
    }
  }

  const beforeSubmit = () => {
    // TODO:バリデーションチェック

    setIsConfirmModalShow(true)
  }

  const submit = async () => {
    try {
      // DB更新用リスト
      const newReq: TGetuziSimesyoriPutReq = {
        年: prevSearchCondition!.年,
        締め確定区分コード: prevSearchCondition!.締め確定区分コード,
        年月List: gridData.data.items
          .filter((d) => d.締め状態 === e締め状態.確定)
          .map((d) => {
            // 検索年/確定月/1
            return `${prevSearchCondition!.年}/${d.月}/1`
          }),
      }

      const res = await new GetuziSimesyoriService().put(newReq)

      disPatch(setAlerts(res))
      if (res) {
        showInfoToast(`月次締め処理管理の更新が完了しました。`)
      }

      // リストア中フラグON
      setIsRestoreSearching(true)

      // 再検索
      // Ref更新などをValidationの中で行ってるため、検索前に経由させる。
      search(prevSearchCondition).finally(() => {
        disPatch(画面ロック解除())
      })
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 検索時のチェック
   */
  const isValidationCheckBeforeSearch = () => {
    disPatch(clearAlert())
    Form外エラーメッセージList.splice(0, Form外エラーメッセージList.length)

    let hasError = false
    let messages: Array<string> = []

    if (hasError) {
      Form外エラーメッセージList.push(...messages)
      setHasSearched(hasError)
    } else {
    }
    return !hasError
  }
  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [pageSize, setPageSize] = useState<number>(10)

  // グリッド用
  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [gridData, setGridData] = useState<{
    data: wjCore.CollectionView<T締め年月入力Item>
  }>({
    data: createCollectionView([], true),
  })

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中
  const [isSubmitButton, setIsSubmitButton] = useState(false) // 検索後

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const disPatch: AppDispatch = useDispatch()

  const [prevSearchCondition, setPrevSearchCondition] =
    useState<TGetuziSimesyoriListGetReq>()

  // errorフラグ
  const [hasSearched, setHasSearched] = useState(false)
  const [Form外エラーメッセージList] = useState<string[]>([])

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [年, set年] = useState<number>(parseInt(dayjs(eigyobi).format("YYYY")))

  // 年
  const [年ComboBox, set年ComboBox] = useState<TWijmoComboBox<
    number | undefined,
    T年ComboBoxItem
  > | null>(null)
  const [年IsLoadEnded, set年IsLoadEnded] = useState<boolean>(false)

  const [締め確定区分ComboBox, set締め確定区分ComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [締め確定区分ItemsSource, set締め確定区分ItemsSource] =
    useState<T区分マスタ[]>()
  const [締め確定区分コード, set締め確定区分コード] = useState<string | null>()
  const [締め確定区分IsLoadEnded, set締め確定区分IsLoadEnded] =
    useState<boolean>(false)

  const [締め状態DataMap] = useState<wjcGrid.DataMap>(
    new wjcGrid.DataMap(
      [
        { text: "", value: e締め状態.未確定 },
        { text: "確定", value: e締め状態.確定 },
      ],
      "value",
      "text"
    )
  )
  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `月次締め処理管理`
    // 初期表示生成のため画面ロック
    disPatch(画面ロック開始())
  }, [])

  //kubun
  useEffect(() => {
    Promise.all([
      new KubunService().getList({
        分類コード: 区分分類コード.マスタ.締め確定区分,
      }),
    ]).then(([区分マスタRes]) => {
      const ユーザー解放済み締め確定区分List = [
        e締め確定区分.乗務員出勤簿,
        e締め確定区分.事務員出勤簿,
        e締め確定区分.乗務員給与締め処理,
      ]
      set締め確定区分ItemsSource(
        区分マスタRes.data.filter((d) =>
          ユーザー解放済み締め確定区分List.includes(d.区分コード)
        )
      )
    })
  }, [])

  // error監視
  useEffect(() => {
    if (hasSearched && [...Form外エラーメッセージList].find((e) => e !== "")) {
      disPatch(setWarningAlerts([...Form外エラーメッセージList]))
    }
    setHasSearched(false)
  }, [hasSearched])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && 締め確定区分IsLoadEnded) {
      // 年初期化
      set年(parseInt(dayjs(eigyobi).format("YYYY")))

      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        // Ref更新などをValidationの中で行ってるため、検索前に経由させる。
        // if (isValidationCheckBeforeSearch()) {
        search(querySearchCondition).finally(() => {
          disPatch(画面ロック解除())
        })
        // }
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        disPatch(画面ロック解除())
      }
    }
  }, [gridInitialized, 締め確定区分IsLoadEnded])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">月次締め処理管理</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-40rem">
            {/* CardHeaderをアコーディオン化 ⇒ 入力対象キーでもあるため、一旦制御無し */}
            <Card.Header
              // onClick={() => setAccordionController(!accordionController)}
              onClick={() => setAccordionController(true)}
              aria-controls="collapse-search-card-body"
              aria-expanded={true}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={true}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    {/* 固定項目 */}
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-12rem">
                              <YearComboBox
                                placeholder="年"
                                is年度={false}
                                isLoadEnded={年IsLoadEnded}
                                isRequired={true}
                                setIsLoadEnded={set年IsLoadEnded}
                                selectedValue={年}
                                setSelectedValue={(v) => {
                                  set年(
                                    v ?? parseInt(dayjs(eigyobi).format("YYYY"))
                                  )
                                }}
                                ComboBox={年ComboBox}
                                setComboBox={set年ComboBox}></YearComboBox>
                            </div>
                            <div className="w-20rem">
                              <ComboBox.Kubun
                                placeholder="締め確定区分"
                                itemsSource={締め確定区分ItemsSource}
                                selectedValue={締め確定区分コード}
                                setSelectedValue={set締め確定区分コード}
                                isLoadEnded={締め確定区分IsLoadEnded}
                                isRequired={true}
                                setIsLoadEnded={set締め確定区分IsLoadEnded}
                                ComboBox={締め確定区分ComboBox}
                                setComboBox={
                                  set締め確定区分ComboBox
                                }></ComboBox.Kubun>
                            </div>
                            <Button
                              type="submit"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                beforeSearch()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card className="w-40rem">
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              {/* 休日区分ごとにGridを分割 */}
              <div className="d-flex">
                <div className="overflow-auto">
                  <FlexGridOuter
                    flexGrid={flexGrid}
                    setFlexGrid={setFlexGrid}
                    gridConstantProperties={
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                    }
                    gridData={gridData}
                    setGridData={setGridData}
                    pageNumber={0}
                    gridId={`${gridId}_1`}
                    isRestoreSearching={isRestoreSearching}
                    setIsRestoreSearching={setIsRestoreSearching}
                    gridInitialized={gridInitialized}
                    setGridInitialized={setGridInitialized}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    gridInitializedHandler={gridInitializedHandler}
                    gridProperties={{
                      allowAddNew: false,
                      allowDelete: false,
                      allowResizing: false,
                      allowSorting: false,
                      selectionMode: wjcGrid.SelectionMode.Cell,
                    }}
                    hasFilter={false}
                    isShowGridHeader={false}
                    isShowGridRowPickupButton={false}
                    isShowGridFooter={false}>
                    <wjrGrid.FlexGridColumn
                      binding="月"
                      width={70}
                      cssClass={"read-only-cell"}
                      isReadOnly={true}
                      header="月">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<T締め年月入力Item>
                        ) => {
                          return `${context.item.月}月`
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="締め状態"
                      width={90}
                      dataMap={締め状態DataMap}
                      isRequired={true}
                      header="締め状態"></wjrGrid.FlexGridColumn>
                  </FlexGridOuter>
                </div>
              </div>

              <Row>
                <Col>
                  <div>
                    <Button
                      type="button"
                      variant={isSubmitButton ? "waiting" : "secondary"}
                      disabled={!isSubmitButton}
                      onClick={() => {
                        beforeSubmit()
                      }}>
                      登録
                    </Button>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </Container>
  )
}

export default GetuziSimesyoriRegister
